export function removeAllCustomArrayMethods() {
  for (let prop in Array.prototype) {
    if (Array.prototype.propertyIsEnumerable(prop)) {
      delete Array.prototype[prop];
    }
  }
}
